/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './ClaimHistoryTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { Box } from '@mui/system';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface contentTileType {
  claimName: string;
  amount: number;
  travelDate: string;
  status?: any;
  onClick?: any;
  trans?: any;
}
const ClaimHistoryTile: React.FC<contentTileType> = ({
  travelDate,
  claimName,
  amount,
  status,
  onClick,
  trans,
}) => {
  return (
    <Grid container className="claim-history-container">
      <Grid item xs={10}>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.title,
              fontFamily: fonts.fontFamily,
              color: themes.blackDefault,
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {claimName}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
              marginTop: '10px',
            }}
          >
            {trans('Amount')}{' '}
            <span style={{ color: themes.blackDefault }} className="mx-1">
              {amount}
            </span>{' '}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '2px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Claim Date:')}{' '}
            <span style={{ color: themes.blackDefault }} className="mx-1">
              <DateField value={travelDate} format={baseDateFormatting} />
            </span>{' '}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Status:')}{' '}
            {status == 0 ? (
              <span style={{ color: themes.defaultMisc }}>
                {trans('Waiting for Approval')}
              </span>
            ) : status == 2 ? (
              <span style={{ color: themes.defaultError }}>
                {trans('Rejected')}
              </span>
            ) : (
              <span style={{ color: themes.defaultSuccess }}>
                {trans('Approved')}
              </span>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={2}
        style={{
          textAlign: 'right',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box className="icon-box_leave_history" onClick={onClick}>
          {' '}
          <i className="las la-eye" color={themes.primaryMain} />{' '}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ClaimHistoryTile;
